module.exports = __webpack_public_path__ + "img/galeria-desportiva-1.b4751a55.jpg";